// participantDisplay.js — Fase 1 pos-simulado Savassi (2026-10-28). Rotulo
// humano de um participante da Presence: nome autorizado (users.full_name,
// resolvido no servidor), depois a organizacao. O operatorId tecnico
// (guest:/invite:<id>) nunca e exibido como nome; continua sendo a chave de
// admissao, correlacao e auditoria.
const TECHNICAL_INVITE_ID = /^(guest|invite):/i;

export function participantDisplayName(participant = {}) {
    const name = String(participant?.name || participant?.full_name || '').trim();
    if (name) return name;
    const organization = String(participant?.organization || '').trim();
    if (organization) return organization;
    const operatorId = String(participant?.operatorId || '').trim();
    if (TECHNICAL_INVITE_ID.test(operatorId)) return 'Convidado';
    return operatorId || null;
}

export default { participantDisplayName };
